export default {
  assetsBidInfos(state){
    return state.assetsBidInfos;
  }
};
